import isIncognito from "./incognito";
import browser from "./browser";

export { isIncognito, browser };